import { createAction, props } from '@ngrx/store';

export const setEditMode = createAction(
  '[Common] Set Edit Mode',
  props<{ editMode: boolean }>()
);

export const setDefaultFilter = createAction(
  '[Common] Set Default Filter',
  props<{ url: string; defaultFilter: Object }>()
);
